import React from "react";
import { Container } from "reactstrap";
// used for making the prop types of this component
import PropTypes from "prop-types";

class Footer extends React.Component {
  render() {
    return (
      <footer
        className={"footer" + (this.props.default ? " footer-default" : "")}
      >
        <Container fluid={this.props.fluid ? true : false}>
          <nav>
            <ul>
              <li>
                <a
                  href="https://github.com/cesar3030/my-sodastream-dashboard"
                  target="_blank"
                >
                  GitHub project
                </a>
              </li>
            </ul>
          </nav>
          <div className="copyright">
            &copy; {1900 + new Date().getYear()}, Coded by{" "}
            <a
              href="http://www.cesarjeanroy.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Cesar Jeanroy
            </a>
            .
          </div>
        </Container>
      </footer>
    );
  }
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx